import React from "react";

function RightSideLayout2() {
  return <React.Fragment>{/* <QuickPanel /> */}</React.Fragment>;
}

export default RightSideLayout2;
